/**
 * Welke kamers heeft DEZE browser aangemaakt?
 *
 * DIT IS EEN BRIEFJE EN GEEN SLOT. Het houdt de kostenbalk weg bij je gast,
 * die de link krijgt en verder niets weet. Het houdt niemand tegen die zelf
 * gaat zoeken: wat in localStorage staat, kan iedereen aanpassen.
 *
 * Het echte slot zit aan de SERVERKANT, op /rooms/:id/kosten achter de
 * beheerpoort. Die poort laat in ontwikkeling nog iedereen door en gaat dicht
 * in stap 15, samen met de debugregel. Tot dan is dit het verschil tussen
 * "je gast ziet het per ongeluk" en "je gast ziet het niet".
 *
 * Bewust GEEN lijst met alles erin: alleen de id's, en nooit de pincode.
 */

const SLEUTEL = 'tolk.mijnKamers';

/** Hoeveel kamers we onthouden. Genoeg voor een dag werken, geen archief. */
const MAX = 50;

function lees(): string[] {
  try {
    const ruw = localStorage.getItem(SLEUTEL);
    if (ruw === null) return [];
    const uit: unknown = JSON.parse(ruw);
    // Alles wat geen lijst met tekst is, gooien we weg in plaats van te
    // vertrouwen: dit veld is door de gebruiker te bewerken.
    return Array.isArray(uit) ? uit.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    // Geen opslag (privevenster), volle schijf, of onleesbare inhoud. In alle
    // drie de gevallen is het antwoord hetzelfde: dan weten we het niet.
    return [];
  }
}

export function onthoudMijnKamer(id: string): void {
  try {
    const nu = lees().filter((x) => x !== id);
    nu.unshift(id);
    localStorage.setItem(SLEUTEL, JSON.stringify(nu.slice(0, MAX)));
  } catch {
    // Niet kunnen onthouden is geen reden om het aanmaken te laten mislukken.
    // Je mist dan de balk; het gesprek werkt gewoon.
  }
}

export function isMijnKamer(id: string): boolean {
  return lees().includes(id);
}
